import { Environ } from "../types/Environ";

const getEnv = (): Environ | undefined => {
  const mode = import.meta.env.MODE;
  switch (mode) {
    case "local":
    case "development":
      return Environ.LOCAL;
    case "test":
      return Environ.TEST;
    case "dev":
      return Environ.DEV;
    case "prod":
    case "production":
      return Environ.PROD;
    default:
      return undefined;
  }
};

export default getEnv;
